import React from 'react';
import { HoInvitedBetterWayToBuildContainer } from '../../common';
import BetterWayDesktop from './BetterWayDesktop';
import BetterWayMobile from './BetterWayMobile';

const InvitedByContractorBetterWayToBuild: React.FC = () => (
  <HoInvitedBetterWayToBuildContainer numberOfSlides={6}>
    <BetterWayDesktop />
    <BetterWayMobile />
  </HoInvitedBetterWayToBuildContainer>
);

export default InvitedByContractorBetterWayToBuild;
